import { render } from "./MergeDuplicates.vue?vue&type=template&id=56c4922e&scoped=true"
import script from "./MergeDuplicates.vue?vue&type=script&lang=js"
export * from "./MergeDuplicates.vue?vue&type=script&lang=js"

import "./MergeDuplicates.vue?vue&type=style&index=0&id=56c4922e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56c4922e"]])

export default __exports__